import React, { useEffect, useState } from 'react';

export default function CurrentDateTime() {
    const [currentTime, setCurrentTime] = useState('');
  
    useEffect(() => {
      const updateTime = () => {
        const now = new Date();
        const pad = n => String(n).padStart(2, '0');
        const formatted = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        setCurrentTime(formatted);
      };
  
      updateTime();
      const timer = setInterval(updateTime, 1000);
  
      return () => clearInterval(timer);
    }, []);
  
    return (
      <div className="datetime">
        {currentTime}
      </div>
    );
}
